import { createAction, props } from '@ngrx/store';

export const setToken = createAction('[Auth] Set Token', props<{ token: string | null }>());
export const setUser = createAction('[Auth] Set User', props<{ user: any | null }>());
export const setSelectedAgency = createAction('[Auth] Set Selected Agency', props<{ agency: any | null }>());

/** Logout / session expired: forget everything */
export const clearSession = createAction('[Auth] Clear Session');
